<template>
  <img
    src="https://www.samsungfire.com/m/resources/images/front/bg_csl03.png"
    height="80"
    width="82"
    alt="mail"
    class="-mr-2 h-12 min-w-10 self-center object-cover object-left"
  />
</template>

<script lang="ts" setup></script>

<style scoped></style>
